export default __webpack_public_path__ + "static/media/WelcomePenguin.a1684b67.svg";